import "./Navbar.css";

export default function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-logo">MediMetrics</div>
      <ul className="navbar-links">
        <li><a href="#Navbar.js">Home</a></li>
        <li><a href="#about-section">About</a></li>
        <li><a href="#overview-section">Overview</a></li>
        <li><a href="https://medimetrics-patient-web.vercel.app/">Login / Signup</a></li>
      </ul>
    </nav>
  );
}
